import { render, staticRenderFns } from "./ExclusionsInfo.vue?vue&type=template&id=036c7d80"
import script from "./ExclusionsInfo.vue?vue&type=script&lang=js"
export * from "./ExclusionsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports